import { render, staticRenderFns } from "./Scholarships.vue?vue&type=template&id=f75bd148&scoped=true"
import script from "./Scholarships.vue?vue&type=script&lang=js"
export * from "./Scholarships.vue?vue&type=script&lang=js"
import style0 from "./Scholarships.vue?vue&type=style&index=0&id=f75bd148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75bd148",
  null
  
)

export default component.exports